import React, { useCallback, useState } from "react";
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Header, Logo } from "./common";
import { useInput } from '../../../hooks';
import { emailRegExp } from "../../../utils/utilityEtc";
import { errorMessage } from '../../../redux/errorState';
import { URL } from '../../../constant';
import A from "../../common/A";

/**
 * 매쓰피드 로그인
 */
function Login(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { POLICY } = URL.ACCOUNT;
  const [email, onChangeEmail, onEmailReset] = useInput('');
  const [pw, onChangePw, onPwReset] = useInput('');
  const [emailError, setEmailError] = useState(false);
  const [pwError, setPwError] = useState(false);

  const onBlur = useCallback(() => {
    if (!email) return;
    // 이메일 양식이 맞으면  true 아니면 false;
    const result = emailRegExp(email);
    setEmailError(!result);
  }, [email]);

  const onSubmit = () => {
    if (emailError) return;
    if (!email || !pw) {
      dispatch(errorMessage('msg', '이메일 또는 비밀번호를 입력하세요.'));
      return;
    }

    history.push(URL.SELECT_LEARNING);
  }

  const onReset = (type) => {
    if (type === 'email') {
      onEmailReset();
      setEmailError(false);
    } else if (type === 'pw') {
      onPwReset();
      setPwError(false);
    }
  }

  const handlePage = (path) => {
    history.push(path);
  }
  
  return (
    <React.Fragment>
      <Header isMenuBtn title="로그인" />
      <div className="layout-def log_in with_bottom_area">
        <div className="container">
          <div className="inner">
            <div className="center_wrap">
              <Logo logoPath={"static/images/common/logo_white@2x.png"} />
              <div className="input_wrap">
                <form>
                  <article>
                    <div className="input_box soft_white_box">
                      <input
                        type="text"
                        value={email}
                        placeholder="이메일 주소 입력"
                        onChange={onChangeEmail}
                        onBlur={onBlur}
                      />
                      <div className="r_area">
                        {
                          emailError && (
                            <button type="button" onClick={() => onReset('email')}>
                              <img
                                width="40"
                                src="/static/images/icon/ic_error2@2x.png"
                                alt=""
                              />
                            </button>
                          )
                        }
                      </div>
                    </div>
                    {
                      emailError && (
                        <div className="red_txt fs14">
                          올바른 이메일 형식이 아닙니다. 예)abc@mathpid.com
                        </div>
                      )
                    }
                  </article>
                  <article>
                    <div className="input_box soft_white_box">
                      <input
                        value={pw}
                        type="password"
                        placeholder="비밀번호 입력"
                        onChange={onChangePw}
                      />
                      <div className="r_area">
                        {
                          pwError > 0 && (
                            <button
                              type="button"
                              onClick={() => onReset('pw')}
                            >
                              <img
                                width="40"
                                src="./static/images/icon/ic_error2@2x.png"
                                alt=""
                              />
                            </button>
                          )
                        }
                      </div>
                    </div>
                    {
                      pwError && (
                        <div className="red_txt fs14">
                          이메일 주소와 비밀번호가 일치하지 않습니다. 이메일 주소
                          또는 비밀번호를 다시 확인해 주세요.
                        </div>
                      )
                    }
                  </article>
                </form>
              </div>
              <div className="lower_wrap cls">
                <div className="left">
                  <div className="custom-radio-wrap custom-radio-white chk_font_white">
                    <input type="checkbox" id="login_chk" />
                    <label htmlFor="login_chk">로그인 상태 유지</label>
                  </div>
                </div>
                <div className="right cls">
                  <A>로그인</A>
                  <span />
                  <A onClick={() => handlePage(POLICY.I)}>회원가입</A>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom_wrap btn_wrap">
            <A className="btn btn-white" onClick={onSubmit}>로그인</A>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Login;
